import { useRouter } from 'next/router';

import { useAdDetailsContext } from '../../../../../contexts/AdDetailsContext';

import type { ReserveCTAArgs } from './ReserveCTA.typed';
import { RESERVATION_STATUS } from '../../types';

import { asString } from 'utils/query-parameters';
import { pushToDataLayer } from 'services/gtmService';

import {
  TRUSTAP_CODE_CANCELLED,
  TRUSTAP_CODE_QUERY_KEY,
  TRUSTAP_STATUS_OK,
  TRUSTAP_STATUS_QUERY_KEY,
} from '../../constants/trustap';

export const useReserveCTA = (args: ReserveCTAArgs) => {
  const { reservationStatus } = args;

  const { setIsReservationModalOpen } = useAdDetailsContext();

  const { query } = useRouter();

  /**
   * When the user is returned from the checkout screen, a query parameter is appended to the URL
   * to indicate that the reservation was successful (trustap_status=ok).
   *
   * To avoid a race condition whereby the API reservation field is not updated before the user is returned to the page,
   * we check if this query exists to determine if the reserve option for the listing should be disabled.
   *
   * However, if the user clicks back from Trustap, the query parameter "code=cancelled" is also added. We therefore check for both
   * to determine whether the user actually completed the process or just dropped off.
   */
  const disabled =
    (asString(query[TRUSTAP_STATUS_QUERY_KEY]) === TRUSTAP_STATUS_OK &&
      asString(query[TRUSTAP_CODE_QUERY_KEY]) !== TRUSTAP_CODE_CANCELLED) ||
    reservationStatus === RESERVATION_STATUS.DISABLED;

  const onClick = () => {
    setIsReservationModalOpen(true);
    pushToDataLayer({
      event: 'click_on_reserve',
    });
  };

  return { disabled, onClick };
};
